"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSystemMoistureLoadId = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.setSystemMoistureLoadId = (0, graphql_tag_1.default) `
  mutation SetSystemMoistureLoadId($moistureLoadId: ID, $systemId: ID!) {
    setSystemMoistureLoadId(
      moistureLoadId: $moistureLoadId
      systemId: $systemId
    )
  }
`;
//# sourceMappingURL=set-system-moisture-load-id.js.map